import { MimeType } from './mime-types';

export const data_uri = (mimetype: MimeType) => (b64: string) =>
    `data:${mimetype};base64,${b64}`;
